import ACTIONS from '../actions';

const initialState = {
  isMobile: false,
  mobileView: '',
};

const ResponsiveReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─────────────────────────────────────
    // RESPONSIVE
    // ─────────────────────────────────────
    case ACTIONS.SET_RESPONSIVE:
      return {
        ...state,
        isMobile: action.payload,
        // Reset to rooms list view whenever we cross the breakpoint
        mobileView: action.payload ? state.mobileView : 'rooms',
      };

    case ACTIONS.SET_MOBILE_VIEW:
      return {
        ...state,
        mobileView: action.payload,
      };
    default:
      return state;
  }
};

export default ResponsiveReducer;
